import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-label d-flex align-items-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "input-wrapper position-relative" }
const _hoisted_4 = {
  key: 0,
  class: "fix prefix-container"
}
const _hoisted_5 = ["type", "value", "data-testid"]
const _hoisted_6 = {
  key: 3,
  class: "fix suffix-container"
}

import { computed, VNode } from 'vue';

import { InputIconPosition, InputVariant } from '@/types';

interface Props {
  label?: string;
  type?: string;
  variant?: InputVariant;
  inputClass?: string | string[];
  icon?: string | object | (() => VNode) | null;
  labelIcon?: string | object | (() => VNode) | null;
  prefix?: string | null;
  suffix?: string | null;
  position?: InputIconPosition;
  testId?: string;
  required?: boolean;
}
export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: /*@__PURE__*/_mergeModels({
    label: { default: "" },
    type: { default: "text" },
    variant: { default: "primary" },
    inputClass: { default: "" },
    icon: { type: [String, Object, Function, null], default: null },
    labelIcon: { type: [String, Object, Function, null], default: null },
    prefix: { default: null },
    suffix: { default: null },
    position: { default: "start" },
    testId: { default: "input" },
    required: { type: Boolean, default: false }
  }, {
    "modelValue": { default: "" },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "startIconClick", "endIconClick"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel<string | number>(__props, "modelValue");

;

const props = __props

const emit = __emit;

const variantClass = computed(() => props.variant ?? 'primary');

const inputStyles = computed(() => {
  const styles = {
    paddingLeft: '',
    paddingRight: '',
    background: 'none',
  };

  if (props.icon && props.position === 'start') {
    styles.paddingLeft = '2.25rem';
  } else if (props.prefix) {
    styles.paddingLeft = '3.125rem';
  }
  
  if (props.icon && props.position === 'end') {
    styles.paddingRight = '2.25rem';
  } else if (props.suffix) {
    styles.paddingRight = '3.125rem';
  }

  if (modelValue.value && ['primary', 'admin'].includes(props.variant ?? '')) {
    styles.background = 'rgba(28, 86, 145, 0.05)';
  }

  return styles;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['w-100', variantClass.value])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
                key: 1,
                class: "ms-1"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (__props.prefix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.prefix), 1))
        : _createCommentVNode("", true),
      (__props.icon && __props.position === 'start')
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "component-wrapper component-start",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('startIconClick')))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon)))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", _mergeProps({
        type: __props.type,
        class: __props.inputClass,
        style: inputStyles.value,
        value: modelValue.value,
        "data-testid": __props.testId,
        onInput: _cache[1] || (_cache[1] = e => emit('update:modelValue', (e.target as HTMLInputElement).value)),
        autocomplete: "on"
      }, _ctx.$attrs), null, 16, _hoisted_5),
      (__props.icon && __props.position === 'end')
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "component-wrapper component-end",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('endIconClick')))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon)))
          ]))
        : _createCommentVNode("", true),
      (__props.suffix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.suffix), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})